/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button } from 'react-bootstrap';
import SVGComponent from '../SVGComponents/SVGComponents';
import { PaperComponent } from '../utilities/utilities';

export default (props) => {
  const {
    open,
    title,
    moduleName,
    onConfim,
    onCancel,
    onClose,
    content,
    isInfo = false,
  } = props;
  return (
    <>
      <Dialog
        open={open}
        data-testid="handleSaveClose"
        className="multiGroupDialog custom-dialog-box dialog-420"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogContent>
          <div className="custom-panel">
            <div
              className="panel-header"
              style={{ cursor: 'move' }}
              id="draggable-dialog-title"
            >
              <span className="float-left"> {title} </span>
              <span
                className="float-right"
                role="button"
                onClick={title === 'Close' ? onClose : onCancel}
                tabIndex={'0'}
                onKeyDown={(e) => {
                  // Handle Enter and Space key events
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault(); // Prevents the default space scrolling behavior
                    title === 'Close' ? onClose() : onCancel();
                  }
                }}
                aria-label="Close" // Optional: Provide a label for screen readers
                aria-role="button"
              >
                <i className="fa fa-times-circle" />
              </span>

              <div className="clearfix" />
            </div>
            <div
              className={
                title === 'Close' ||
                (moduleName && moduleName.includes('for Check Log Number'))
                  ? 'text-center mt-3'
                  : title === 'Delete Plan'
                  ? 'm-3'
                  : 'text-center modal-alignment'
              }
            >
              <DialogContentText style={{ color: 'black' }}>
                {title === 'Delete'
                  ? `Are you sure you want to delete ${moduleName}?`
                  : title === 'Delete Plan'
                  ? content
                  : title === 'Delete Group'
                  ? content
                  : title === 'Default Setting'
                  ? content
                  : title === 'Save'
                  ? content ||
                    'Are you sure you want to Save your changes? To revert changes, click on Cancel'
                  : title === 'Save & Continue'
                  ? 'There are unsaved changes on the ROSI/PQAS tab. Do you want to Save and Continue?'
                  : title === 'Change'
                  ? content
                  : title === 'Close'
                  ? 'There are unsaved changes. Do you want to Save and Close?'
                  : title === 'Received Date'
                  ? 'Received Date is at least 30 days in the past, Are you sure?'
                  : title?.includes('ROSI/PQAS')
                  ? content
                  : title?.includes('Inv #')
                  ? 'Leave now and suspend check?'
                  : title === 'Delete Provider' ||
                    title === 'Delete Ineligible CPT'
                  ? content
                  : 'There are unsaved changes. Do you want to continue?'}
              </DialogContentText>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          {!isInfo ? (
            <div className="btn-wrapper my-2">
              <Button
                onClick={onConfim}
                data-testid="masterDataSave"
                className="btn btn-success btn-search mr-2"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Yes
              </Button>
              <Button
                onClick={onCancel}
                className="btn btn-cancel btn-primary mr-2"
                color="primary"
                autoFocus
              >
                <SVGComponent iconName="Icon-cancel" />
                No
              </Button>
            </div>
          ) : (
            <div className="btn-wrapper my-2">
              <Button
                onClick={onConfim}
                data-testid="masterDataSave"
                className="btn btn-success btn-search mr-2"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Close
              </Button>
            </div>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};